import { keyPressSequence } from './operators';
import { Subject } from 'rxjs';
export var useDetectKeySequence = function (sequence, callback) {
    var keydownStream = new Subject();
    var keyUpStream = new Subject();
    keyPressSequence(sequence, keydownStream, keyUpStream).subscribe(function () { return callback(); });
    return {
        onKeyUp: function (event) { return keyUpStream.next(event); },
        onKeyDown: function (event) { return keydownStream.next(event); }
    };
};
//# sourceMappingURL=use-detect-key-sequence.js.map